<template>
	<div class="row text-center">
		<div class="col-xs-12">
			<div class="modal-assinatura-eletronica__teclado-btn-group" role="group" aria-label="...">
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 1)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					1
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 2)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					2
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 3)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					3
				</button>
			</div>
		</div>
		<div class="col-xs-12">
			<div class="modal-assinatura-eletronica__teclado-btn-group" role="group" aria-label="...">
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 4)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					4
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 5)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					5
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 6)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					6
				</button>
			</div>
		</div>

		<div class="col-xs-12">
			<div class="modal-assinatura-eletronica__teclado-btn-group" role="group" aria-label="...">
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 7)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					7
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 8)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					8
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 9)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					9
				</button>
			</div>
		</div>

		<div class="col-xs-12">
			<div
				class="modal-assinatura-eletronica__teclado-btn-group modal-assinatura-eletronica__teclado-btn-group--last-item"
				role="group"
				aria-label="..."
			>
				<button
					type="button"
					@click="$emit('limpar-assinatura')"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn modal-assinatura-eletronica__teclado-btn--apagar"
				>
					{{ _traducao('global', 'limpar') }}
				</button>
				<button
					type="button"
					@click="$emit('adicionar-caractere-na-assinatura', 0)"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn"
				>
					0
				</button>
				<button
					type="button"
					@click="$emit('apagar-ultimo-caractere-na-assinatura')"
					class="btn btn-default modal-assinatura-eletronica__teclado-btn modal-assinatura-eletronica__teclado-btn--apagar"
				>
					<i class="fa fa-long-arrow-left" aria-hidden="true"></i>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ModalAssinaturaEletronicaTeclado'
}
</script>

<style scoped>
.modal-assinatura-eletronica__teclado-btn-group {
	display: flex;
	gap: 4px;
	margin-bottom: 4px;
}

.modal-assinatura-eletronica__teclado-btn-group--last-item {
	margin-bottom: 0;
}

.modal-assinatura-eletronica__teclado-btn {
	width: 33.33%;
	margin-top: 0px;
}

.modal-assinatura-eletronica__teclado-btn--apagar {
	background-color: #f7f7f7;
}
</style>